import * as M from 'shared/types/models';

export function defaultCellConverter(cell: M.AbstractCell | M.StandardContent) {
  if (M.typeGuards.isAbstractCell(cell)) {
    return cell.content;
  }
  return cell;
}
